import { supabase, isSupabaseConfigured } from './supabaseClient';

const EPISODE_COLUMNS = 'id, episode_number, title, air_date, body_html, published, created_at, updated_at';

function requireClient() {
  if (!isSupabaseConfigured() || !supabase) {
    throw new Error('Supabase is not configured.');
  }
  return supabase;
}

export async function fetchPublishedEpisodes() {
  const client = requireClient();
  const { data, error } = await client
    .from('fgtn_episodes')
    .select('id, episode_number, title, air_date, published')
    .eq('published', true)
    .order('episode_number', { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function fetchAllEpisodes() {
  const client = requireClient();
  const { data, error } = await client
    .from('fgtn_episodes')
    .select(EPISODE_COLUMNS)
    .order('episode_number', { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function fetchEpisodeByNumber(episodeNumber, { includeUnpublished = false } = {}) {
  const client = requireClient();
  let query = client
    .from('fgtn_episodes')
    .select(EPISODE_COLUMNS)
    .eq('episode_number', episodeNumber);

  if (!includeUnpublished) {
    query = query.eq('published', true);
  }

  const { data, error } = await query.maybeSingle();
  if (error) throw error;
  return data;
}

export async function upsertEpisode(episode) {
  const client = requireClient();
  const payload = {
    episode_number: episode.episode_number,
    title: episode.title,
    air_date: episode.air_date,
    body_html: episode.body_html || '',
    published: episode.published !== false,
  };

  const query = episode.id
    ? client.from('fgtn_episodes').update(payload).eq('id', episode.id)
    : client.from('fgtn_episodes').insert(payload);

  const { data, error } = await query.select(EPISODE_COLUMNS).single();
  if (error) throw error;
  return data;
}

export async function deleteEpisode(id) {
  const client = requireClient();
  const { error } = await client
    .from('fgtn_episodes')
    .delete()
    .eq('id', id);

  if (error) throw error;
}

export async function getFgtnSession() {
  const client = requireClient();
  const { data, error } = await client.auth.getSession();
  if (error) throw error;
  return data.session || null;
}

export async function signInFgtnAdmin(email, password) {
  const client = requireClient();
  const { data, error } = await client.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data.session;
}

export async function signOutFgtnAdmin() {
  const client = requireClient();
  const { error } = await client.auth.signOut();
  if (error) throw error;
}
